import { render } from "./myPrivacy.vue?vue&type=template&id=19390eaa&scoped=true&ts=true"
import script from "./myPrivacy.vue?vue&type=script&lang=ts"
export * from "./myPrivacy.vue?vue&type=script&lang=ts"

import "./myPrivacy.vue?vue&type=style&index=0&id=19390eaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19390eaa"]])

export default __exports__